import { SoapUtils } from "../../../../utils/SoapUtils";

export interface ProjectItem {
    amount?: string;
    amountWithVat?: string;
    approved?: string;
    approvedBy?: string;
    approvedByName?: string;
    billingDate?: string;
    nextBillingDate?: string;
    billingStatus?: string;
    totalQuantity?: string;
    convertToNextPeriod?: string;
    budgetId?: string;
    customer?: string;
    provider?: string;
    customerName?: string;
    providerName?: string;
    catalogPrice?: string;
    componentCategory?: string;
    created?: string;
    createdByName?: string;
    currency?: string;
    distGroup?: string;
    formId?: string;
    formValue?: string;
    freeValue?: string;
    freeQuantity?: string;
    id?: string;
    invoiceId?: string;
    item?: string;
    itemType?: string;
    itemSerial?: string;
    language?: string;
    manufacturer?: string;
    manufacturerName?: string;
    modified?: string;
    modifiedByName?: string;
    maxLen?: string;
    name?: string;
    note?: string;
    orderId?: string;
    parentId?: string;
    priceType?: string;
    priceTypeName?: string;
    priority?: string;
    project?: string;
    projectMasterProject?: string;
    projectName?: string;
    projectState?: string;
    projectCustomState?: string;
    projectStatusName?: string;
    purchasePrice?: string;
    purchasePriceDefault?: string;
    quantity?: string;
    recordId?: string;
    recurringId?: string;
    refId?: string;
    refIdBudget?: string;
    refIdInvoice?: string;
    refIdOrder?: string;
    serviceLevel?: string;
    serviceLevelName?: string;
    serviceMonths?: string;
    status?: string;
    statusName?: string;
    folder?: string;
    folderName?: string;
    folderStatusColor?: string;
    folderRole?: string;
    totalAmount?: string;
    totalAmountWithVat?: string;
    type?: string;
    typeName?: string;
    units?: string;
    unitsName?: string;
    vat?: string;
    vatValue?: string;
    ratio?: string;
    dimension1?: string;
    dimension1Name?: string;
    dimension2?: string;
    dimension2Name?: string;
    dimension3?: string;
    dimension3Name?: string;
    taxationDate?: string;
    fixAmount?: string;
    isModelItem?: string;
    splitInInvoice?: string;
    fixText?: string;
    isContainer?: string;
    estimateTransaction?: string;
    containderId?: string;
    availableFreeQuantity?: string;
    containderName?: string;
    recommended?: string;
    recommendedName?: string;
    validFrom?: string;
    validTo?: string;
    destinationProject?: string;
    activity?: string;
    typeOfActivity?: string;
    typeOfActivityName?: string;
    billingFrequency?: string;
    fromTimeSheet?: string;
    orderIndex?: string;
    purchasedQty?: string;
    soldQty?: string;
    attrib0?: string;
    attrib0_id?: string;
    attrib1?: string;
    attrib1_id?: string;
    attrib2?: string;
    attrib2_id?: string;
    attrib3?: string;
    attrib3_id?: string;
    attrib4?: string;
    attrib4_id?: string;
    attrib5?: string;
    attrib5_id?: string;
    attrib6?: string;
    attrib6_id?: string;
    attrib7?: string;
    attrib7_id?: string;
    attrib8?: string;
    attrib8_id?: string;
    attrib9?: string;
    attrib9_id?: string;
    currencyRate?: string;
    supplier?: string;
    purchaseCurrency?: string;
    purchaseCurrencyRate?: string;
    totalAmountBccy?: string;
    totalPurchase?: string;
    totalPurchaseBccy?: string;
    catalogPriceBccy?: string;
    supplierName?: string;
    purchasePriceBccy?: string;
  }

  export function toProjectItemXML(item:ProjectItem): string{
    var parameters: string = "";

    parameters += SoapUtils.makeNode(item.amount, 'amount');
    parameters += SoapUtils.makeNode(item.amountWithVat, 'amountWithVat');
    parameters += SoapUtils.makeNode(item.approved, 'approved');
    parameters += SoapUtils.makeNode(item.approvedBy, 'approvedBy');
    parameters += SoapUtils.makeNode(item.approvedByName, 'approvedByName');
    parameters += SoapUtils.makeNode(item.billingDate, 'billingDate');
    parameters += SoapUtils.makeNode(item.nextBillingDate, 'nextBillingDate');
    parameters += SoapUtils.makeNode(item.billingStatus, 'billingStatus');
    parameters += SoapUtils.makeNode(item.totalQuantity, 'totalQuantity');
    parameters += SoapUtils.makeNode(item.convertToNextPeriod, 'convertToNextPeriod');
    parameters += SoapUtils.makeNode(item.budgetId, 'budgetId');
    parameters += SoapUtils.makeNode(item.customer, 'customer');
    parameters += SoapUtils.makeNode(item.provider, 'provider');
    parameters += SoapUtils.makeNode(item.customerName, 'customerName');
    parameters += SoapUtils.makeNode(item.providerName, 'providerName');
    parameters += SoapUtils.makeNode(item.catalogPrice, 'catalogPrice');
    parameters += SoapUtils.makeNode(item.componentCategory, 'componentCategory');
    parameters += SoapUtils.makeNode(item.created, 'created');
    parameters += SoapUtils.makeNode(item.createdByName, 'createdByName');
    parameters += SoapUtils.makeNode(item.currency, 'currency');
    parameters += SoapUtils.makeNode(item.distGroup, 'distGroup');
    parameters += SoapUtils.makeNode(item.formId, 'formId');
    parameters += SoapUtils.makeNode(item.formValue, 'formValue');
    parameters += SoapUtils.makeNode(item.freeValue, 'freeValue');
    parameters += SoapUtils.makeNode(item.freeQuantity, 'freeQuantity');
    parameters += SoapUtils.makeNode(item.id, 'id');
    parameters += SoapUtils.makeNode(item.invoiceId, 'invoiceId');
    parameters += SoapUtils.makeNode(item.item, 'item');
    parameters += SoapUtils.makeNode(item.itemType, 'itemType');
    parameters += SoapUtils.makeNode(item.itemSerial, 'itemSerial');
    parameters += SoapUtils.makeNode(item.language, 'language');
    parameters += SoapUtils.makeNode(item.manufacturer, 'manufacturer');
    parameters += SoapUtils.makeNode(item.manufacturerName, 'manufacturerName');
    parameters += SoapUtils.makeNode(item.modified, 'modified');
    parameters += SoapUtils.makeNode(item.modifiedByName, 'modifiedByName');
    parameters += SoapUtils.makeNode(item.maxLen, 'maxLen');
    parameters += SoapUtils.makeNode(item.name, 'name');
    parameters += SoapUtils.makeNode(item.note, 'note');
    parameters += SoapUtils.makeNode(item.orderId, 'orderId');
    parameters += SoapUtils.makeNode(item.parentId, 'parentId');
    parameters += SoapUtils.makeNode(item.priceType, 'priceType');
    parameters += SoapUtils.makeNode(item.priceTypeName, 'priceTypeName');
    parameters += SoapUtils.makeNode(item.priority, 'priority');
    parameters += SoapUtils.makeNode(item.project, 'project');
    parameters += SoapUtils.makeNode(item.projectMasterProject, 'projectMasterProject');
    parameters += SoapUtils.makeNode(item.projectName, 'projectName');
    parameters += SoapUtils.makeNode(item.projectState, 'projectState');
    parameters += SoapUtils.makeNode(item.projectCustomState, 'projectCustomState');
    parameters += SoapUtils.makeNode(item.projectStatusName, 'projectStatusName');
    parameters += SoapUtils.makeNode(item.purchasePrice, 'purchasePrice');
    parameters += SoapUtils.makeNode(item.purchasePriceDefault, 'purchasePriceDefault');
    parameters += SoapUtils.makeNode(item.quantity, 'quantity');
    parameters += SoapUtils.makeNode(item.recordId, 'recordId');
    parameters += SoapUtils.makeNode(item.recurringId, 'recurringId');
    parameters += SoapUtils.makeNode(item.refId, 'refId');
    parameters += SoapUtils.makeNode(item.refIdBudget, 'refIdBudget');
    parameters += SoapUtils.makeNode(item.refIdInvoice, 'refIdInvoice');
    parameters += SoapUtils.makeNode(item.refIdOrder, 'refIdOrder');
    parameters += SoapUtils.makeNode(item.serviceLevel, 'serviceLevel');
    parameters += SoapUtils.makeNode(item.serviceLevelName, 'serviceLevelName');
    parameters += SoapUtils.makeNode(item.serviceMonths, 'serviceMonths');
    parameters += SoapUtils.makeNode(item.status, 'status');
    parameters += SoapUtils.makeNode(item.statusName, 'statusName');
    parameters += SoapUtils.makeNode(item.folder, 'folder');
    parameters += SoapUtils.makeNode(item.folderName, 'folderName');
    parameters += SoapUtils.makeNode(item.folderStatusColor, 'folderStatusColor');
    parameters += SoapUtils.makeNode(item.folderRole, 'folderRole');
    parameters += SoapUtils.makeNode(item.totalAmount, 'totalAmount');
    parameters += SoapUtils.makeNode(item.totalAmountWithVat, 'totalAmountWithVat');
    parameters += SoapUtils.makeNode(item.type, 'type');
    parameters += SoapUtils.makeNode(item.typeName, 'typeName');
    parameters += SoapUtils.makeNode(item.units, 'units');
    parameters += SoapUtils.makeNode(item.unitsName, 'unitsName');
    parameters += SoapUtils.makeNode(item.vat, 'vat');
    parameters += SoapUtils.makeNode(item.vatValue, 'vatValue');
    parameters += SoapUtils.makeNode(item.ratio, 'ratio');
    parameters += SoapUtils.makeNode(item.dimension1, 'dimension1');
    parameters += SoapUtils.makeNode(item.dimension1Name, 'dimension1Name');
    parameters += SoapUtils.makeNode(item.dimension2, 'dimension2');
    parameters += SoapUtils.makeNode(item.dimension2Name, 'dimension2Name');
    parameters += SoapUtils.makeNode(item.dimension3, 'dimension3');
    parameters += SoapUtils.makeNode(item.dimension3Name, 'dimension3Name');
    parameters += SoapUtils.makeNode(item.taxationDate, 'taxationDate');
    parameters += SoapUtils.makeNode(item.fixAmount, 'fixAmount');
    parameters += SoapUtils.makeNode(item.isModelItem, 'isModelItem');
    parameters += SoapUtils.makeNode(item.splitInInvoice, 'splitInInvoice');
    parameters += SoapUtils.makeNode(item.fixText, 'fixText');
    parameters += SoapUtils.makeNode(item.isContainer, 'isContainer');
    parameters += SoapUtils.makeNode(item.estimateTransaction, 'estimateTransaction');
    parameters += SoapUtils.makeNode(item.containderId, 'containderId');
    parameters += SoapUtils.makeNode(item.availableFreeQuantity, 'availableFreeQuantity');
    parameters += SoapUtils.makeNode(item.containderName, 'containderName');
    parameters += SoapUtils.makeNode(item.recommended, 'recommended');
    parameters += SoapUtils.makeNode(item.recommendedName, 'recommendedName');
    parameters += SoapUtils.makeNode(item.validFrom, 'validFrom');
    parameters += SoapUtils.makeNode(item.validTo, 'validTo');
    parameters += SoapUtils.makeNode(item.destinationProject, 'destinationProject');
    parameters += SoapUtils.makeNode(item.activity, 'activity');
    parameters += SoapUtils.makeNode(item.typeOfActivity, 'typeOfActivity');
    parameters += SoapUtils.makeNode(item.typeOfActivityName, 'typeOfActivityName');
    parameters += SoapUtils.makeNode(item.billingFrequency, 'billingFrequency');
    parameters += SoapUtils.makeNode(item.fromTimeSheet, 'fromTimeSheet');
    parameters += SoapUtils.makeNode(item.orderIndex, 'orderIndex');
    parameters += SoapUtils.makeNode(item.purchasedQty, 'purchasedQty');
    parameters += SoapUtils.makeNode(item.soldQty, 'soldQty');
    parameters += SoapUtils.makeNode(item.attrib0, 'attrib0');
    parameters += SoapUtils.makeNode(item.attrib0_id, 'attrib0_id');
    parameters += SoapUtils.makeNode(item.attrib1, 'attrib1');
    parameters += SoapUtils.makeNode(item.attrib1_id, 'attrib1_id');
    parameters += SoapUtils.makeNode(item.attrib2, 'attrib2');
    parameters += SoapUtils.makeNode(item.attrib2_id, 'attrib2_id');
    parameters += SoapUtils.makeNode(item.attrib3, 'attrib3');
    parameters += SoapUtils.makeNode(item.attrib3_id, 'attrib3_id');
    parameters += SoapUtils.makeNode(item.attrib4, 'attrib4');
    parameters += SoapUtils.makeNode(item.attrib4_id, 'attrib4_id');
    parameters += SoapUtils.makeNode(item.attrib5, 'attrib5');
    parameters += SoapUtils.makeNode(item.attrib5_id, 'attrib5_id');
    parameters += SoapUtils.makeNode(item.attrib6, 'attrib6');
    parameters += SoapUtils.makeNode(item.attrib6_id, 'attrib6_id');
    parameters += SoapUtils.makeNode(item.attrib7, 'attrib7');
    parameters += SoapUtils.makeNode(item.attrib7_id, 'attrib7_id');
    parameters += SoapUtils.makeNode(item.attrib8, 'attrib8');
    parameters += SoapUtils.makeNode(item.attrib8_id, 'attrib8_id');
    parameters += SoapUtils.makeNode(item.attrib9, 'attrib9');
    parameters += SoapUtils.makeNode(item.attrib9_id, 'attrib9_id');
    parameters += SoapUtils.makeNode(item.currencyRate, 'currencyRate');
    parameters += SoapUtils.makeNode(item.supplier, 'supplier');
    parameters += SoapUtils.makeNode(item.purchaseCurrency, 'purchaseCurrency');
    parameters += SoapUtils.makeNode(item.purchaseCurrencyRate, 'purchaseCurrencyRate');
    parameters += SoapUtils.makeNode(item.totalAmountBccy, 'totalAmountBccy');
    parameters += SoapUtils.makeNode(item.totalPurchase, 'totalPurchase');
    parameters += SoapUtils.makeNode(item.totalPurchaseBccy, 'totalPurchaseBccy');
    parameters += SoapUtils.makeNode(item.catalogPriceBccy, 'catalogPriceBccy');
    parameters += SoapUtils.makeNode(item.supplierName, 'supplierName');
    parameters += SoapUtils.makeNode(item.purchasePriceBccy, 'purchasePriceBccy');

    return parameters;
  }